<div id="bot-details" [formGroup]="form">
  <table class="table-striped table-td-border-right table-no-border-bottom">
    <tr class="bot-message-container">
      <td colspan="2" id="bot-name">
        <mat-label>API Key</mat-label>
        <input class="destination-input-field" type="text" formControlName="apiKey" [placeholder]="isApiKeySet ? 'Value hidden' : ''"/>
      </td>
      <td colspan="2">
        <mat-label>API Secret</mat-label>
        <input class="destination-input-field" type="text" formControlName="apiSecret" [placeholder]="isApiSecretSet ? 'Value hidden' : ''"/>
      </td>
    </tr>
  </table>
</div>
